<template>
  <button
    class="nav-btn group inline-flex w-auto cursor-pointer select-none flex-row items-center gap-3"
    :class="{ 'flex-row-reverse': reversed }"
    :disabled="isDisabled"
  >
    <span class="text-lg font-medium leading-8" :class="{ 'text-[#9EA4AD]': isDisabled }">{{ label }}</span>

    <img
      class="translate-y-[1px] transition duration-75"
      :class="[imgHoverClass]"
      :src="reversed ? LeftArrow.src : RightArrow.src"
    />
  </button>
</template>

<script setup lang="ts">
import RightArrow from "./RightArrow.svg";
import LeftArrow from "./LeftArrow.svg";
import { computed } from "vue";

const props = defineProps({
  label: { type: String, required: true },
  isDisabled: { type: Boolean, default: false },
  reversed: { type: Boolean, default: false },
});

const imgHoverClass = computed(() => {
  if (props.isDisabled) return "";
  return props.reversed ? "group-hover:-translate-x-2" : "group-hover:translate-x-2";
});
</script>

<style lang="scss" scoped>
.nav-btn {
  &[disabled],
  &[disabled] * {
    @apply cursor-not-allowed text-theme-1 opacity-[65%];
  }
}
</style>
